import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/button/ActionButton';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import { AddIcon } from 'assets/materialIcons/materialIcons';

const GenericAddButton = (props) => {
    const { translate, handleOnClick } = props;

    return (
        <Button
            icon={ <AddIcon color={ theme.palette.doveGray }/> }
            title={ translate('actions.add') }
            onClick={ handleOnClick }
        />
    );
};

GenericAddButton.propTypes = {
    handleOnClick: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

export default translate(GenericAddButton);


// WEBPACK FOOTER //
// ./src/components/button/GenericAddButton.js